// Import the functions you need from the SDKs you need
import { getAuth } from 'firebase/auth';
import {
  getFirestore,
  collection,
} from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBLAZrgtzmLAW61KUuSP7BnYyU9c8aJTv4',
  authDomain: 'dance-app-fb049.firebaseapp.com',
  projectId: 'dance-app-fb049',
  storageBucket: 'dance-app-fb049.appspot.com',
  messagingSenderId: '455531853620',
  appId: '1:455531853620:web:e9d71d46354a78e392d761',
  measurementId: 'G-C4CT9MN03Z',
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
// auth.tenantId = 'root-05fr7'; // config.tenantId;
const db = getFirestore();

// https://stackoverflow.com/questions/70052479/firebase-storage-an-unknown-error-occurred-please-check-the-error-payload-for
// The console error is not sufficent. It does not give enough information.
//
// When viewing the console error you need to click the other red POST 400 error shown in the console. This will take you to the Network tab. From there scroll down and click the offending red error. This should finally show you a more helpful error message that reads something like this:
//
// Permission denied. Please enable Firebase Storage for your bucket by visiting the Storage tab in the Firebase Console and ensure that you have sufficient permission to properly provision resources.
// This may lead you to think that it's your Firebase Storage rules to blame. And you should double check those rules before continuing, but the more likely problem is that you are missing an esoteric firebase-storage@system.gserviceaccount.com permission inside the Google Cloud Console.
//
// To fix that take these steps:
//
// Go to https://console.cloud.google.com
// Select your project in the top blue bar (you will probably need to switch to the "all" tab to see your Firebase projects)
// Scroll down the left menu and select "Cloud Storage"
// Select all your buckets then click "Show INFO panel" in the top right hand corner
// click "ADD PRINCIPAL"
// Add "firebase-storage@system.gserviceaccount.com" to the New Principle box and give it the role of "Storage Admin" and save it
const storage = getStorage();

// if (__DEV__) {
//   console.log('Switching to local Firebase instance...');
//   const origin =
//     Constants.manifest?.debuggerHost?.split(':').shift() || 'localhost';
//   // const origin = "192.168.68.119";
//   connectAuthEmulator(auth, 'http://' + origin + ':9099');
//   connectFirestoreEmulator(db, origin, 8081);
//   connectStorageEmulator(storage, origin, 9199);
// }

export const createCollection = (collectionName) => {
  const tenantId = auth.tenantId || 'root-05fr7';
  return collection(
    db,
    'tenant',
    tenantId,
    collectionName,
  )
};

export const createSubCollection = (
  collectionName,
  documentName,
  subCollectionName,
) => {
  const tenantId = auth.tenantId || 'root-05fr7';
  return collection(
    db,
    'tenant',
    tenantId,
    collectionName,
    documentName,
    subCollectionName,
  );
};

export { auth, storage, db };
export default app;
